import { promisify } from "./utils/Promisify";

function openDrawerFnDescriptor(
  drawerName: string,
  switchValue: string,
  executeCondition: string,
  triggerSetting: string,
  debounceAndThrottleTime: number,
) {
  return {
    type: "OPEN_DRAWER_BY_NAME" as const,
    payload: {
      name: drawerName,
      switchValue,
      executeCondition,
      triggerSetting,
      debounceAndThrottleTime,
    },
  };
}

export type TOpenDrawerArgs = Parameters<typeof openDrawerFnDescriptor>;
export type TOpenDrawerDescription = ReturnType<typeof openDrawerFnDescriptor>;
export type TOpenDrawerActionType = TOpenDrawerDescription["type"];

async function openDrawer(...args: TOpenDrawerArgs) {
  return promisify(openDrawerFnDescriptor)(...args);
}

function closeDrawerFnDescriptor(
  drawerName: string,
  switchValue: string,
  executeCondition: string,
  triggerSetting: string,
  debounceAndThrottleTime: number,
) {
  return {
    type: "CLOSE_DRAWER" as const,
    payload: {
      name: drawerName,
      switchValue,
      executeCondition,
      triggerSetting,
      debounceAndThrottleTime,
    },
  };
}

export type TCloseDrawerArgs = Parameters<typeof closeDrawerFnDescriptor>;
export type TCloseDrawerDescription = ReturnType<
  typeof closeDrawerFnDescriptor
>;
export type TCloseDrawerActionType = TCloseDrawerDescription["type"];

async function closeDrawer(...args: TCloseDrawerArgs) {
  return promisify(closeDrawerFnDescriptor)(...args);
}

export { openDrawer, closeDrawer };
